import { useMemo } from 'react'
import { SocialIcon } from 'react-social-icons'

import { StyledButtonsContainer } from './styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

// QRM-594: only absolute http(s) URLs may be rendered as profile links —
// anything else (empty string, javascript:, relative path) counts as unconfigured
const isValidProfileLink = (link?: string): link is string =>
  Boolean(link && /^https?:\/\//i.test(link.trim()))

export const ShareButtons = () => {
  const companyData = useMySelector((state) => state.app.companyData)

  const profileLinks = useMemo(() => {
    const configured: Array<{ network: string; href: string }> = [
      { network: 'facebook', href: companyData?.FacebookLink },
      { network: 'x', href: companyData?.TwitterLink },
      { network: 'whatsapp', href: companyData?.WhatsAppLink },
      { network: 'pinterest', href: companyData?.PinterestLink },
    ]
      .filter((item): item is { network: string; href: string } =>
        isValidProfileLink(item.href)
      )
      .map(({ network, href }) => ({ network, href: href.trim() }))
    return configured
  }, [companyData])

  // QRM-594: icons link to the restaurant's own profiles (console-configured,
  // hssoft.com-Companies); an unconfigured network renders no icon at all
  if (!profileLinks.length) return null

  return (
    <StyledButtonsContainer>
      {profileLinks.map(({ network, href }) => (
        <SocialIcon
          key={network}
          network={network}
          url={href}
          target="_blank"
          rel="noopener noreferrer"
        />
      ))}
    </StyledButtonsContainer>
  )
}
